import { getPermissions, hasPermission } from "../../utilis/permissionStorage";
import { useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import { apiUrl } from "../ApiManager/AxiosHeaders";
import Swal from "sweetalert2";

const ManageTeams = () => {
  const [permissions, setPermissions] = useState({});
  const [teamModel, setTeamModel] = useState(false);
  const [team, setTeam] = useState({
    id: "",
    name: "",
    description: "",
  });
  const [editTeam, setEditTeam] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [showSkeleton, setShowSkeleton] = useState(false);
  const [users, setUsers] = useState([]);
  const [memberModal, setMemberModal] = useState(false);
  const [selectedTeamId, setSelectedTeamId] = useState(null);
  const [selectedUsers, setSelectedUsers] = useState([]);

  useEffect(() => {
    const perms = getPermissions();
    if (perms) {
      setPermissions(perms);
    }
  }, []);

  useEffect(() => {
    fetchTeamsWithUser();
    fetchAllActiveUsers();
  }, []);

  const [errors, setErrors] = useState({});

  const fetchAllActiveUsers = async () => {
    try {
      const response = await apiUrl.get("/fetchAllActiveUsers");
      if (response.status) {
        setUsers(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = (field, value) => {
    setTeam((pre) => ({
      ...pre,
      [field]: value,
    }));
    if (errors[field]) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[field];
        return newErrors;
      });
    }
  };

  const fetchTeamsWithUser = async () => {
    try {
      setShowSkeleton(true);
      const response = await apiUrl.get("/teams");
      if (response?.status) {
        setData(response?.data?.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setShowSkeleton(false);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!team?.name) newErrors.name = "Team name is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    setLoading(true);

    try {
      if (editTeam && team.id) {
        const response = await apiUrl.put(`/teams/${team.id}`, {
          name: team.name,
          description: team.description || null,
        });

        if (response?.status) {
          Swal.fire({
            title: "Team Updated Successfully",
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
            toast: true,
            position: "top-end",
          });
        }
      } else {
        const response = await apiUrl.post("/add_team", {
          name: team.name,
          description: team.description || null,
        });

        if (response?.status) {
          Swal.fire({
            title: response.data.message,
            icon: "success",
            timer: 3000,
            showConfirmButton: false,
            toast: true,
            position: "top-end",
          });
        }
      }

      setTeamModel(false);
      fetchTeamsWithUser();
    } catch (error) {
      Swal.fire({
        title: error.response?.data?.error || "Error",
        icon: "error",
        timer: 3000,
        showConfirmButton: false,
        toast: true,
        position: "top-end",
      });
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteTeam = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This action cannot be undone!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await apiUrl.delete(`/teams/${id}`);
          if (response?.data?.status) {
            Swal.fire({
              title: response.data.message,
              icon: "success",
              timer: 3000,
              toast: true,
              showConfirmButton: false,
              position: "top-end",
            });
            fetchTeamsWithUser();
          }
        } catch (error) {
          Swal.fire({
            title: error.response?.data?.message || "Error deleting team",
            icon: "error",
            timer: 3000,
            toast: true,
            showConfirmButton: false,
            position: "top-end",
          });
        }
      }
    });
  };

  const handleSaveMembers = async () => {
    try {
      const response = await apiUrl.post(`/teams/${selectedTeamId}/members`, {
        user_ids: selectedUsers,
      });

      if (response?.data?.status) {
        Swal.fire({
          title: response.data.message,
          icon: "success",
          timer: 3000,
          toast: true,
          showConfirmButton: false,
          position: "top-end",
        });
        setMemberModal(false);
        fetchTeamsWithUser();
      }
    } catch (error) {
      Swal.fire({
        title: error.response?.data?.message || "Error saving members",
        icon: "error",
        timer: 3000,
        toast: true,
        showConfirmButton: false,
        position: "top-end",
      });
    }
  };

  return (
    <>
      {permissions && (
        <div>
          <header className="border-bottom bg-light">
            <div className="container px-4 py-3">
              <div className="d-flex align-items-center justify-content-between">
                <div>
                  <h1 className="h3 fw-bold">Manage Teams</h1>
                  <p className="text-muted small">
                    Manage Teams and assigned, remove users
                  </p>
                </div>
                <button
                  className="btn btn-primary"
                  onClick={() => {
                    setTeamModel(true);
                    setEditTeam(false);
                    setTeam({
                      name: "",
                      description: "",
                    });
                  }}
                >
                  Add Team
                </button>
              </div>
            </div>
          </header>

          {/* Team Table - FIXED ALIGNMENT */}
          <div className="container py-4">
            <div className="card border">
              <div className="table-responsive">
                <table className="table table-hover align-middle mb-0">
                  <thead className="table-light">
                    <tr>
                      <th className="text-center align-middle">Team Name</th>
                      <th className="text-center align-middle">Description</th>
                      <th className="text-center align-middle">Members</th>
                      <th className="text-center align-middle">Created At</th>
                      <th className="text-center align-middle">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Skeleton Loader */}
                    {showSkeleton && (
                      <>
                        {[1, 2, 3].map((i) => (
                          <tr key={i}>
                            <td className="text-center">
                              <span className="placeholder col-6"></span>
                            </td>
                            <td className="text-center">
                              <span className="placeholder col-8"></span>
                            </td>
                            <td className="text-center">
                              <span className="placeholder col-3"></span>
                            </td>
                            <td className="text-center">
                              <span className="placeholder col-5"></span>
                            </td>
                            <td className="text-center">
                              <span className="placeholder col-4"></span>
                            </td>
                          </tr>
                        ))}
                      </>
                    )}

                    {/* No Teams */}
                    {!showSkeleton && data.length === 0 && (
                      <tr>
                        <td colSpan="5" className="text-center text-muted py-3">
                          No teams found.
                        </td>
                      </tr>
                    )}

                    {/* Team Data */}
                    {!showSkeleton &&
                      data.map((item) => (
                        <tr key={item.id}>
                          <td className="text-center align-middle fw-medium">
                            {item.name}
                          </td>
                          <td className="text-center align-middle">
                            {item.description || (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td className="text-center align-middle">
                            <span className="badge bg-primary rounded-pill">
                              {item.users?.length || 0}
                            </span>
                          </td>
                          <td className="text-center align-middle">
                            {new Date(item.created_at).toLocaleDateString(
                              "en-US",
                              {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              }
                            )}
                          </td>
                          <td className="text-center align-middle">
                            {/* FIXED BUTTON LAYOUT */}
                            <div className="d-flex justify-content-center gap-2 flex-nowrap">
                              {/* Manage Members */}
                              <button
                                className="btn btn-info btn-sm d-flex align-items-center gap-1"
                                style={{ minWidth: "100px" }}
                                onClick={() => {
                                  setSelectedTeamId(item.id);
                                  const currentMemberIds =
                                    item.users?.map((u) => u.id) || [];
                                  setSelectedUsers(currentMemberIds);
                                  setMemberModal(true);
                                }}
                              >
                                <FaIcons.FaUser />
                                <span>Members</span>
                              </button>

                              {/* Edit */}
                              <button
                                className="btn btn-warning btn-sm d-flex align-items-center gap-1"
                                style={{ minWidth: "80px" }}
                                onClick={() => {
                                  setEditTeam(true);
                                  setTeam({
                                    id: item.id,
                                    name: item.name,
                                    description: item.description,
                                  });
                                  setTeamModel(true);
                                }}
                              >
                                <FaIcons.FaEdit />
                                <span>Edit</span>
                              </button>

                              {/* Delete */}
                              <button
                                className="btn btn-danger btn-sm d-flex align-items-center gap-1"
                                style={{ minWidth: "80px" }}
                                onClick={() => handleDeleteTeam(item.id)}
                              >
                                <FaIcons.FaTrash />
                                <span>Delete</span>
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Team Modal */}
          {teamModel && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1040,
                }}
                onClick={() => setTeamModel(false)}
              />

              <div
                className="modal fade show d-block"
                tabIndex={-1}
                style={{ zIndex: 1050 }}
              >
                <div
                  className="modal-dialog modal-dialog-centered"
                  style={{ maxWidth: 700 }}
                >
                  <div
                    className="modal-content border-0 rounded-4 shadow"
                    style={{ overflow: "hidden" }}
                  >
                    <div
                      className="modal-header"
                      style={{
                        background: "#f7f8fa",
                        borderBottom: "1px solid #eef2f6",
                      }}
                    >
                      <h5 className="modal-title fw-bold">
                        {editTeam ? "Update Team" : "Add Team"}
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setTeamModel(false)}
                      />
                    </div>

                    <div className="modal-body">
                      <div className="d-flex flex-column gap-3">
                        <div>
                          <label className="form-label mb-1">
                            Team Name
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            className={`form-control ${
                              errors.name ? "is-invalid" : ""
                            }`}
                            value={team.name}
                            placeholder="e.g., Off Shore Team"
                            onChange={(e) =>
                              handleInputChange("name", e.target.value)
                            }
                          />
                          {errors.name && (
                            <div className="invalid-feedback d-block">
                              {errors.name}
                            </div>
                          )}
                        </div>

                        <div>
                          <label className="form-label mb-1">Description</label>
                          <textarea
                            className="form-control"
                            rows="4"
                            value={team.description}
                            placeholder="Enter team description"
                            onChange={(e) =>
                              handleInputChange("description", e.target.value)
                            }
                          />
                        </div>
                      </div>
                    </div>

                    <div
                      className="modal-footer d-flex justify-content-end align-items-center gap-2"
                      style={{
                        background: "#f7f8fa",
                        borderTop: "1px solid #eef2f6",
                      }}
                    >
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => setTeamModel(false)}
                        disabled={loading}
                      >
                        Cancel
                      </button>

                      <button
                        className="btn btn-primary"
                        onClick={handleSave}
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" />
                            Saving...
                          </>
                        ) : (
                          <>{editTeam ? "Update Team" : "Save Team"}</>
                        )}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}

          {/* Manage Members Modal */}
          {memberModal && (
            <>
              <div
                className="modal-backdrop fade show"
                style={{
                  display: "block",
                  backgroundColor: "rgba(0,0,0,0.45)",
                  zIndex: 1060,
                }}
                onClick={() => setMemberModal(false)}
              />
              <div
                className="modal fade show d-block"
                tabIndex={-1}
                style={{ zIndex: 1070 }}
              >
                <div className="modal-dialog modal-dialog-centered modal-lg">
                  <div className="modal-content border-0 rounded-4 shadow">
                    <div
                      className="modal-header"
                      style={{
                        background: "#f7f8fa",
                        borderBottom: "1px solid #eef2f6",
                      }}
                    >
                      <h5 className="modal-title fw-bold">
                        Manage Team Members
                      </h5>
                      <button
                        type="button"
                        className="btn-close"
                        onClick={() => setMemberModal(false)}
                      />
                    </div>

                    <div
                      className="modal-body"
                      style={{ maxHeight: "50vh", overflowY: "auto" }}
                    >
                      <div className="mb-4">
                        <h6 className="mb-2">
                          Selected Members ({selectedUsers?.length})
                        </h6>
                        {selectedUsers?.length === 0 ? (
                          <p className="text-muted small">
                            No members selected
                          </p>
                        ) : (
                          <div className="d-flex flex-wrap gap-2">
                            {users
                              ?.filter((user) =>
                                selectedUsers?.includes(user.id)
                              )
                              ?.map((user) => (
                                <span
                                  key={user.id}
                                  className="badge bg-primary d-flex align-items-center"
                                  style={{ padding: "0.4rem 0.8rem" }}
                                >
                                  {user.name}
                                  <button
                                    type="button"
                                    className="btn-close btn-close-white ms-2"
                                    style={{ fontSize: "0.7rem", opacity: 0.8 }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedUsers((prev) =>
                                        prev.filter((id) => id !== user.id)
                                      );
                                    }}
                                  ></button>
                                </span>
                              ))}
                          </div>
                        )}
                      </div>

                      <div>
                        <h6 className="mb-2">All Users</h6>
                        <div className="row g-2">
                          {users?.map((user) => (
                            <div key={user.id} className="col-md-6">
                              <div
                                className={`border rounded p-3 d-flex align-items-center justify-content-between ${
                                  selectedUsers?.includes(user.id)
                                    ? "border-primary bg-light"
                                    : "border-gray border-2"
                                }`}
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  if (selectedUsers?.includes(user.id)) {
                                    setSelectedUsers((prev) =>
                                      prev.filter((id) => id !== user.id)
                                    );
                                  } else {
                                    setSelectedUsers((prev) => [
                                      ...prev,
                                      user.id,
                                    ]);
                                  }
                                }}
                              >
                                <div>
                                  <div className="fw-medium">{user?.name}</div>
                                  <div className="text-muted small">
                                    {user?.email}
                                  </div>
                                </div>

                                {selectedUsers.includes(user.id) && (
                                  <span className="badge bg-primary">
                                    Selected
                                  </span>
                                )}
                              </div>
                            </div>
                          ))}

                          {users?.length === 0 && (
                            <p className="text-muted text-center">
                              No users available
                            </p>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="modal-footer">
                      <button
                        className="btn btn-secondary"
                        onClick={() => setMemberModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={handleSaveMembers}
                      >
                        Save Members ({selectedUsers?.length})
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ManageTeams;
